import useMedia from 'use-media'
import { DEVICE_MIN_WIDTH_PX } from './device'

export const useLaptopMediaQuery = (): boolean => {
    const isLaptop = useMedia({ minWidth: DEVICE_MIN_WIDTH_PX.laptop })

    return isLaptop
}

export const useDesktopMediaQuery = (): boolean => {
    const isDesktop = useMedia({ minWidth: DEVICE_MIN_WIDTH_PX.desktop })

    return isDesktop
}

export const useTabletMediaQuery = (): boolean => {
    const isTablet = useMedia({ minWidth: DEVICE_MIN_WIDTH_PX.tablet })

    return isTablet
}

export const useDeviceSize = (): 'laptop' | 'desktop' | 'tablet' | 'mobile' => {
    const isLaptop = useLaptopMediaQuery()
    const isDesktop = useDesktopMediaQuery()
    const isTablet = useTabletMediaQuery()

    if (isDesktop) return 'desktop'
    if (isLaptop) return 'laptop'
    if (isTablet) return 'tablet'
    return 'mobile'
}
